import config from '../config';

import cpImg from '../imgs/app-icons-community.png';
import pImg from '../imgs/app-icons-permissions.png';
import wcImg from '../imgs/app-icons-wolfconnect.png';
import qbImg from '../imgs/app-icons-quickbooks.png';
import inImg from '../imgs/app-icons-insights.png';
import brImg from '../imgs/app-icons-banking-reconciliation.png';
import boImg from '../imgs/app-icons-back-office.png';


const apps = {
    WOLF_CONNECT: {
        name: 'WOLFconnect',
        description: 'Access WOLFconnect',
        imgSrc: wcImg,
        appId: 'wc'
    },
    COMMUNITY_PORTAL: {
        name: 'The Community',
        landingUrl: 'https://lwolf.force.com',
        appId: 'cp',
        imgSrc: cpImg
    },
    PERMISSIONS: {
        name: 'Permissions',
        landingUrl: '/security-groups',
        imgSrc: pImg,
        appId: 'permissions'
    },
    QUICK_BOOKS: {
        name: 'QuickBooks',
        description: 'QuickBooks',
        imgSrc: qbImg,
        appId: 'qb'
    },
    INSIGHTS: {
        name: 'Insights',
        description: 'Insights',
        imgSrc: inImg,
        appId: 'INS',
        landingUrl: config.get('INSIGHTS_LANDING_URL'),
        loginUrl: config.get('INSIGHTS_LOGIN_URL')
    },
    BANKING_RECONCILIATION: {
        name: 'Banking Reconciliation',
        description: 'Banking Reconciliation application',
        imgSrc: brImg,
        appId: 'BR',
        landingUrl: config.get('BANKING_RECONCILIATION_LANDING_URL')
    },
    BACK_OFFICE_V4: {
        name: 'Back Office - V4',
        description: 'Back Office - V4 application',
        imgSrc: boImg,
        appId: 'BO-V4',
        landingUrl: config.get('BACK_OFFICE_V4_LANDING_URL')
    }
};

export default apps;